// Hack webrotate 360 to remove the advertising. We're using it under the terms
// of the GPL so we can do whatever we like to it.

import assert from 'assert';
import size from 'lodash/collection/size';

const MOUSE_RIGHT = 3;
const IMAGE_ROTATOR_INTERVALS = [/*'fl', 'fq', 'aV',*/ 'oa', 'pp'];
const CONTEXT_MENU_EVENT_PROP = 'oO';

/**
 * Stop webrotate 360 wasting CPU time by continuously checking and updating
 * its HTML.
 */
function removeSetIntervals(imageRotator) {
    for(let prop of IMAGE_ROTATOR_INTERVALS) {
        if(imageRotator[prop] !== 0) {
            clearInterval(imageRotator[prop]);
        }
        imageRotator[prop] = -1;
    }
}

/**
 * Stop webrotate360 blocking the right click context menu.
 * It stores the 'contextmenu' event name in an obfuscated string. This
 * function deletes the obfuscated event name to prevent it being bound.
 */
function preventContextMenuBlocking(imageRotator) {
    imageRotator[CONTEXT_MENU_EVENT_PROP] = '';
}

/**
 * Stop webrotate 360 showing a custom advertising menu when right clicking.
 *
 * @param imageRotator An ImageRotator instance
 * @param cls The ImageRotator class
 */
function disableAnnoyingRightClickMenu(imageRotator, cls) {
    // The onMouseDown method is used to handle left and right clicks. We only
    // report left clicks to webrotate360 so it never opens the menu.
    imageRotator.onMouseDown = function(e) {
        if(e.which === MOUSE_RIGHT)
            return;
        return cls.prototype.onMouseDown.call(imageRotator, e);
    }
}

/**
 * Get a patched version of the ImageRotator class which disables unwanted
 * webrotate 360 functionality.
 */
function getImprovedImageRotator(imageRotatorCls) {

    function ImprovedRotator(...args) {
        imageRotatorCls.apply(this, args);

        removeSetIntervals(this);
        preventContextMenuBlocking(this);
        disableAnnoyingRightClickMenu(this, ImprovedRotator);
    }
    ImprovedRotator.prototype = Object.create(imageRotatorCls);
    return ImprovedRotator;
}

/**
 * Improve the webrotate 360 library by disabling unwanted functionality.
 */
export function improveWebrotate360() {
    // The strategy used is to use get/set properties to intercept the
    // ImageRotator class being created by the webrotate code. This is neccisary
    // as the library pre-creates the first instance of the class before
    // returning, so we have to patch the ImageRotator after its created, but
    // before they create the first instance.
    if(window.WR360 !== undefined)
        throw new Error('WR360 is already defined, improveWebrotate360() must' +
                        'be run BEFORE the webrotate 360 script is loaded.');

    let wr360 = {},
        ImageRotator;

    Object.defineProperty(window, 'WR360', {
        enumerable: true,
        configurable: false,
        get: () => wr360,
        set: (val) => {
            assert(typeof val === 'object' && size(val) === 0,
                   'Tried to assign non-empty object to window.WR360, this ' +
                   'shouldn\'t happen...');
            // Ignore the attempt to set the value as we always want to use our
            // own hooked version of WR360.
        }
    });

    // Hook the ImageRotator property such that we subclass ImageRotator as it's
    // being set on the WR360 global, before it has a chance to be used.
    Object.defineProperty(wr360, 'ImageRotator', {
        enumerable: true,
        configurable: false,
        get: () => ImageRotator,
        set: (imageRotatorCls) => {
            ImageRotator = getImprovedImageRotator(imageRotatorCls)
        }
    });
}



/** WEBPACK FOOTER **
 ** ./js/improve-webrotate360.js
 **/